module.exports = __webpack_public_path__ + "static/img/l-2.357c0259.png";